export default "__VITE_ASSET__39cb4866__"